const KIND = { BILL: 'billed', QUOTE: 'quoted', PURCHASE_ORDER: 'ordered' };

const shortDate = (d) => (d ? new Date(`${String(d).slice(0, 10)}T00:00:00`).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: '2-digit' }) : '');

const plain = (v) => {
  const n = Number(v);
  return Number.isInteger(n) ? String(n) : n.toFixed(2);
};

/**
 * Under a rate box: the party's last rate for this product and where it came from ("Last billed 105.50, SB-9, 12 Sep 26").
 * When the box holds something else, "Use" puts the last rate (and its discount, when the form has one) back.
 */
function LastRateHint({ last, current, onUse }) {
  if (!last || last.rate == null) return null;
  if (last.source === 'PRICE_LIST') return <PriceListHint last={last} current={current} onUse={onUse} />;
  const same = current !== '' && current != null && Math.abs(Number(current) - Number(last.rate)) < 0.005;
  const discount = last.discountPercent ? ` less ${plain(last.discountPercent)}%` : '';
  return (
    <div className="small text-muted mt-1 text-nowrap" style={{ fontSize: '0.75rem' }}
      title={`${last.document} on ${shortDate(last.date)}${last.quantity != null ? `, quantity ${plain(last.quantity)}` : ''}`}>
      Last {KIND[last.source] || ''} {plain(last.rate)}{discount}
      <span className="d-none d-xl-inline">, {last.document}, {shortDate(last.date)}</span>
      {!same && onUse && (
        <button type="button" className="btn btn-link btn-sm p-0 ms-1 align-baseline" style={{ fontSize: 'inherit' }} onClick={onUse}>Use</button>
      )}
    </div>
  );
}

/** A price from the customer's price list: "Price list Wholesale 2,025", with Use when the box holds something else. */
function PriceListHint({ last, current, onUse }) {
  const same = current !== '' && current != null && Math.abs(Number(current) - Number(last.rate)) < 0.005;
  return (
    <div className="small text-muted mt-1 text-nowrap" style={{ fontSize: '0.75rem' }} title={`Price list ${last.document}`} data-testid="price-list-hint">
      Price list {last.document} {plain(last.rate)}
      {!same && onUse && (
        <button type="button" className="btn btn-link btn-sm p-0 ms-1 align-baseline" style={{ fontSize: 'inherit' }} onClick={onUse}>Use</button>
      )}
    </div>
  );
}

export default LastRateHint;
